import { useState } from 'react';
// @mui
import { MenuItem, Stack } from '@mui/material';
// components
import Image from './image';
import MenuPopover from './menu-popover';
import { IconButtonAnimate } from './animate';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

// export const allLangs = [
//   {
//     label: 'English',
//     value: 'en',
//     icon: '/assets/icons/flags/ic_flag_en.svg',
//   },

//   {
//     label: 'Lao',
//     value: 'la',
//     icon: '/assets/icons/flags/ic_flag_la.svg',
//   }
// ];

export default function LanguagePopover() {



  const { i18n, t } = useTranslation("global");

  const allLangs = [
    {
      label: t("navbar_component.English"),
      value: 'en',
      icon: '/assets/icons/flags/ic_flag_en.svg',
    },

    {
      label: t("navbar_component.Lao"),
      value: 'la',
      icon: '/assets/icons/flags/ic_flag_la.svg',
    }
  ]

  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleChangeLang = (newLang: string) => {
    i18n.changeLanguage(newLang);
    handleClosePopover();
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          width: 40,
          height: 40,
          ...(openPopover && {
            bgcolor: 'action.selected',
          }),
        }}
      >
        <Image disabledEffect src={allLangs?.filter((item) => item?.value === i18n?.language)[0]?.icon} alt="Not found language" />
      </IconButtonAnimate>

      <MenuPopover open={openPopover} onClose={handleClosePopover} sx={{ width: 180 }}>
        <Stack spacing={0.75}>
          {allLangs.map((option, index) => (
            <MenuItem
              key={index}
              selected={option.value === i18n?.language}
              onClick={() => handleChangeLang(option.value)}
            >
              <Image
                disabledEffect
                alt={option.label}
                src={option.icon}
                sx={{ width: 28, mr: 2 }}
              />

              {option.label}
            </MenuItem>
          ))}
        </Stack>
      </MenuPopover>
    </>
  );
}
